import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'

const WordboxStats = ({ lesson: { wordbox, name }, exerciseStats, intl }) => (
  <div className="wordbox-item wordbox-stats">
    <h4>{name}</h4>
    {
      wordbox.text.map((word, wordId) => (
        <React.Fragment key={wordId}>
          {
            wordbox.fillIndexes.includes(wordId) ?
              <span className="selected">{`${wordbox.fillIndexes.indexOf(wordId) + 1}) ${word}`}</span>
            :
              <span className="float-left">{word}</span>
          }
        </React.Fragment>
      ))
    }
    <div className="width-full float-left spacing-top">
      {
        wordbox.fillIndexes.map((answer, answerId) => exerciseStats.answers[answerId] ?
          <div key={answerId} className="item-box">
            <span>{answerId + 1}) {answer.from ? wordbox.text.slice(answer.from, answer.to).join(' ') : wordbox.text[answer]}</span>
            <span>
              {intl.formatMessage(messages.successRate)}:&nbsp;
              {exerciseStats.answers[answerId].successRate} %
            </span>
          </div>
          : null,
        )
      }
    </div>
  </div>
)

WordboxStats.propTypes = {
  lesson: PropTypes.object.isRequired,
  exerciseStats: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
}

export default injectIntl(WordboxStats)

const messages = defineMessages({
  successRate: {
    id: 'stats.exercise.successRate',
    defaultMessage: 'Úspešnosť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/WordboxStats.js